import { useEffect } from 'react';
import '#assets/lcslog.js';
import { getRegionFromCookie } from '#modules/browser';
import { Env } from '#modules/env';

window.lcs_SerName = Env.LCS_SERVER_NAME;
const PREFIX = 'worksmobile';

export function useLCS(stiName) {
  useEffect(() => {
    lcs(stiName);
  }, []);
}

export function lcs(stiName, region = getRegionFromCookie()) {
  if (!window.lcs_SerName || !stiName) return;
  if (!region) return;

  const sti = `${PREFIX}_${stiName}_${region.replace(/[0-9]/g, '')}`;
  window.lcs_do({ sti });
  console.log('NDS LCS sti:', sti);
}
